import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';

export const deliveryTypeToLabelMap: Record<KnownDeliveryDtoDeliveryType, string> = {
  [KnownDeliveryDtoDeliveryType.InboundDryCleaning]: 'Inbound Dry Cleaning',
  [KnownDeliveryDtoDeliveryType.OutboundDryCleaning]: 'Outbound Dry Cleaning',
  [KnownDeliveryDtoDeliveryType.InboundMail]: 'Inbound Mail',
  [KnownDeliveryDtoDeliveryType.OutboundMail]: 'Outbound Mail',
  [KnownDeliveryDtoDeliveryType.InboundParcel]: 'Inbound Parcel',
  [KnownDeliveryDtoDeliveryType.PeerToPeer]: 'Peer to Peer',
  [KnownDeliveryDtoDeliveryType.RetailOrder]: 'Retail Order',
  [KnownDeliveryDtoDeliveryType.LockerpointOrder]: 'Lockerpoint Order'
};
